import { useEffect, useState } from "react";
import useCustomRouting from "../../hooks/useCustomRouting";
import styles from "./styles.module.css";
import CoCoCard from "./CoCoCard";
import { getUrlParams, isValidCocoSource } from "../../utils/utils";
import axiosInstance from "../../api/axios";
import { FormattedMessage, useIntl } from "react-intl";
import {
  PageCocoProfileUpdate,
  PageCocoRemoteConsent,
} from "../../utils/controls";
import { isPageRestricted } from "../../features/configSlice";
import { useDispatch, useSelector } from "react-redux";
import useConsentFragment from "../../hooks/useConsentFragment";
import { setLoader } from "../../features/LoaderSlice";
const CocoContainer = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { redirectToPath } = useCustomRouting();
  const state = useSelector((state) => state.config);
  const urlParams = new URLSearchParams(window.location.search);
  const values = getUrlParams();
  const { getVersionInfo } = useConsentFragment();
  const [hideRemote, setHideRemote] = useState(true);
  const [hidePaper, setHidePaper] = useState(true);

  const getCheckApi = async (obj) => {
    const { controller, scope, type, value } = obj;
    try {
      await axiosInstance.get(
        `check/${controller}/${scope}/${type}/${value}`
      );
      localStorage.removeItem("cocoParams");
    } catch (error) {
      if (
        error?.response?.data?.statusCode == 401 ||
        error.message == "Network Error"
      ) {
        const token = localStorage.getItem("accessToken");
        if (token) {
          const urlParams = new URLSearchParams(location.search);
          localStorage.clear();
          localStorage.setItem("cocoParams", urlParams);
        }
        location.href = "/ui/";
      } else localStorage.removeItem("cocoParams");
    }
  };
  const getVersionInfoDetails = async (obj) => {
    const { controller, scope, language } = obj;
    const data = await getVersionInfo(controller, scope, language);
    const collectMethods = data?.collectMethods;
    if (collectMethods) {
      if (collectMethods?.includes("remote")) setHideRemote(false);
      if (collectMethods?.includes("paper")) setHidePaper(false);
    } else {
      setHidePaper(true);
      if (isPageRestricted(state, PageCocoRemoteConsent)) setHideRemote(true);
      else setHideRemote(false);
    }
  };

  useEffect(() => {
    dispatch(setLoader({ loading: true, label: "" }));
    const obj = {
      controller:
        values?.CountryCode?.toLowerCase() +
        "_" +
        values?.Division?.toLowerCase(),
      scope: "hcp",
      type: values?.SourceSystem?.toLowerCase(),
      value: values.CustomerID,
      language: values?.Language,
    };
    if (obj?.controller && obj?.scope && obj?.type && obj?.value) {
      getCheckApi(obj);
      getVersionInfoDetails(obj);
    }
    dispatch(setLoader({ loading: false, label: "" }));
  }, []);

  const handleRemoteConsentClick = () => [
    redirectToPath(`/coco/remote-consent/?${urlParams}`),
  ];
  const handlePaperConsentClick = () => [
    redirectToPath(`/coco/paper-consent/?${urlParams}`),
  ];
  const handleProfileUpdateClick = () => [
    redirectToPath(`/coco/profile-update/?${urlParams}`),
  ];
  return (
    <div className={styles["container"]}>
      <div className={styles["text-container"]}>
        <p className={styles["coco-header"]}>
          <FormattedMessage
            id="coco.choose-option"
            defaultMessage="Please choose an option"
          />
        </p>
        {/* <p className={styles["coco-warning"]}>
          !Kindly update the legal texts before collecting consent
        </p> */}
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" , justifyContent: "center"}}>
        {!hideRemote && (
          <CoCoCard
            icon="/ui/images/Truman-UI-RemoteConsent.svg"
            title={intl.formatMessage({
              id: "coco.option.remote-consent",
              defaultMessage: "Remote Consent",
            })}
            info={intl.formatMessage({
              id: "coco.option.remote-consent-desc",
              defaultMessage: "Remote consent through personalised invitation",
            })}
            buttonLabel={
              isValidCocoSource(values?.SourceSystem)
                ? intl.formatMessage({
                    id: "label.proceed",
                    defaultMessage: "PROCEED",
                  })
                : ""
            }
            handleProceed={handleRemoteConsentClick}
          />
        )}
        {!isPageRestricted(state, PageCocoProfileUpdate) && (
          <CoCoCard
            icon="/ui/images/Truman-UI-UpdateProfile.svg"
            title={intl.formatMessage({
              id: "coco.option.profile-update",
              defaultMessage: "Profile Update",
            })}
            info={intl.formatMessage({
              id: "coco.option.profile-update-desc",
              defaultMessage:
                "Update HCP personal data for Veeva consent refresh",
            })}
            buttonLabel={
              isValidCocoSource(values?.SourceSystem)
                ? intl.formatMessage({
                    id: "label.proceed",
                    defaultMessage: "PROCEED",
                  })
                : ""
            }
            handleProceed={handleProfileUpdateClick}
          />
        )}
        {!hidePaper && (
          <CoCoCard
            icon="/ui/images/Truman-UI-PaperConsent.svg"
            title={intl.formatMessage({
              id: "coco.option.paper-consent",
              defaultMessage: "Paper Consent",
            })}
            info={intl.formatMessage({
              id: "coco.option.paper-consent-desc",
              defaultMessage: "Face-to-face consent through paper consent form",
            })}
            buttonLabel={
              isValidCocoSource(values?.SourceSystem)
                ? intl.formatMessage({ id: "label.proceed", defaultMessage: "PROCEED" })
                : ""
            }
            handleProceed={handlePaperConsentClick}
          />
        )}
      </div>
    </div>
  );
};

export default CocoContainer;
